module.exports = __webpack_public_path__ + "img/icon_2_22.6000dddc.png";